<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Movie Wise Summary Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-3">
              <div class="dropdown-curve-container" v-if="false">
                <label
                  :class="
                    dropDown.cinemas && dropDown.cinemas.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Select Cinema"
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div> -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                        ✖
                      </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                        ✖
                      </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 d-flex">
          <div class="dropdown-curve-container">
            <multiselect
              class=""
              :allow-empty="false"
              v-model="showTypeFilter"
              placeholder="Select Show Type"
              :options="scheduleStatusArray"
              @select="onSelectShowType($event)"
              label="type"
              track-by="type"
              :multiple="false"
            ></multiselect>
            <label :class="showTypeFilter ? 'shift-up' : ''">
              {{ $t("Type") }}
            </label>
          </div>
        </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="GetMovieWiseSummaryReport((isExcel = 'N'))"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="finalMovieData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a
          target="_blank"
          @click="GetMovieWiseSummaryReport((isExcel = 'Y'))"
          title="Download as Excel"
          download
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
        <a
          target="_blank"
          @click="GetMovieWiseSummaryReport((isExcel = 'N'), 'Y')"
          title="Download as PDF"
          download
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/pdf.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="finalMovieData.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th rowspan="2">S.n</th>
                <th rowspan="2" class="text-left">Movie Name</th>
                <th
                  colspan="2"
                  class="text-left"
                  v-for="(cinema, cinemaIndex) in cinemaNames"
                  :key="cinemaIndex"
                >
                  {{ cinema.cine_name }}
                </th>
                <th rowspan="2" class="text-left">Total Screen</th>
                <th rowspan="2" class="text-right">Total Shows</th>
              </tr>
              <tr>
                <template v-for="(cinema, Index) in cinemaNames">
                  <th class="text-left">SCREEN</th>
                  <th class="text-right">SHOWS</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-for="(movie, movieIndex) in finalMovieData">
                <tr :key="movie.movie_name" style="border: solid black 1px">
                  <td class="text-left">{{ movieIndex + 1 }}</td>
                  <td class="text-left">{{ movie.movie_name }}</td>
                  <template v-for="(cinema, cinemaIndex) in movie.cinemaData">
                    <td :key="cinema.cine_id + '-screen'" class="text-left">
                      {{ cinema.screens_data }}
                    </td>
                    <td :key="cinema.cine_id + '-show'" class="text-right">
                      {{ cinema.show_counts }}
                    </td>
                  </template>

                  <td class="text-right">{{ movie.totalScreens }}</td>
                  <td class="text-right">{{ movie.totalShows }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-scroll">
        <table
  v-if="finalMovieData.length === 0"
  class="swc-report-table swc_table_header"
  border="1"
>
  <thead class="bg-lightgrey">
    <tr>
      <th rowspan="2">S.n</th>
      <th rowspan="2" class="text-left">Movie Name</th>
      <th
        colspan="2"
        class="text-left"
        v-for="(cinema, cinemaIndex) in cinemas"
        :key="cinemaIndex"
      >
        {{ cinema.cine_name }}
      </th>
      <th rowspan="2" class="text-left">Total Screen</th>
      <th rowspan="2" class="text-right">Total Shows</th>
    </tr>
    <tr>
      <template v-for="(cinema, Index) in cinemas">
        <th class="text-left">SCREEN</th>
        <th class="text-right">SHOWS</th>
      </template>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td :colspan="(cinemas.length * 2) + 4">
        <NoRecords />
      </td>
    </tr>
  </tbody>
</table>

      </div>
    </div>
  </div>
</template>
    
    <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      status: [13,16],
      showTypeFilter: { type: "Schedule", status_id: [13,16] },
      scheduleStatusArray: [  
          { type: "All", status_id: null },
          { type: "Schedule", status_id: [13,16] },
          { type: "Planned", status_id: [19] },
        ],
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      finalMovieData: [],
      cinemaNames: [],
      excelFilePath: "",
      cinemas : []
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onSelectShowType(status) {
        this.showTypeFilter = status;
        this.status = status.status_id;
        this.getScheduleOverview();
      },
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemas = data.Records
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      // this.dropDown.selectedCinemaName = event.cine_name;
      //this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetMovieWiseSummaryReport(isExcel = "N", isPdf = "N") {
      this.finalMovieData = [];
      // if (!this.dropDown.selectedCinemaId) {
      //   return this.$toasted.show("Select Cinema");
      // }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        // cinema_id: this.dropDown.selectedCinemaId,
        // cinema_name: this.dropDown.selectedCinemaName || "",
        // cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf: isPdf,
        type: this.status || null,
      };
      ReportsService.GetMovieWiseSummaryReport(payload)
        .then((response) => {
          const { data } = response;
          // console.log("data:", data);

          if (data.status && Object.keys(data.Records).length) {
            this.finalMovieData = data.Records;
            this.cinemaNames = data.CinemaList;
            //console.log("movieSummaryData", this.finalMovieData)
            //console.log("cinemaNames", this.cinemaNames)

            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>
    
    <style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
</style>
    


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/movieWiseSummaryReport.vue